module.exports = __webpack_public_path__ + "media/images/anchor_link01_sp-c1e16ec825da56ae6ea6d15b6f960e49.png";